// extracted by mini-css-extract-plugin
export default {"fullSize":"Loader-index__fullSize--AYL_b"};